import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-truck-scale-a-pro',
  templateUrl: './truck-scale-a-pro.component.html',
  styleUrls: ['./truck-scale-a-pro.component.css']
})
export class TruckScaleAProComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
